import * as React from "react";
import { forwardRef } from "react";
const SvgCornerDownRightLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M2.91667 1.75V5.83333C2.91667 6.45217 3.1625 7.04566 3.60008 7.48325C4.03767 7.92083 4.63116 8.16667 5.25 8.16667H11.6667M9.33333 10.5L11.6667 8.16667L9.33333 5.83333", stroke: "currentColor", strokeWidth: 1.45833, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCornerDownRightLine);
export default ForwardRef;
